import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../../context/ThemeContext';

const BenefitCard = ({ icon, title }) => {
  const { isDarkMode } = useTheme();
  
  return (
    <div className="flex flex-col items-center text-center">
      <div className="w-12 h-12 mb-4">
      {typeof icon === 'string' ? (
          <img 
            src={icon} 
            alt={title}
            className="w-full h-full object-contain"
          />
        ) : (
          // If icon is an SVG element
          <div className="w-full h-full">
            {icon}
          </div>
        )}
      </div>
      <p className={`text-[16px] sm:text-[18px] font-medium ${
        isDarkMode ? 'text-[#fff]' : 'text-[#000]'
      } max-w-[280px] font-lexend`}>
        {title}
      </p>
    </div>
  );
};

const KeyBenefitsSection = () => {
  const { isDarkMode } = useTheme();

  const benefits = [
    {
      icon: (<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 0C4.0365 0 0 4.0365 0 9C0 13.9635 4.0365 18 9 18C13.9635 18 18 13.9635 18 9C18 4.0365 13.9635 0 9 0ZM13.1649 13.305C13.1644 13.305 13.1639 13.3047 13.1636 13.3041C12.4959 11.6621 10.8927 10.5 9.012 10.5H8.988C8.81518 10.5 8.64468 10.5098 8.47702 10.5288C6.19502 10.7881 3.0015 11.2967 3.0015 9C3.0015 5.691 5.6925 3 9.0015 3C12.3105 3 15.0015 5.691 15.0015 9C15.0015 10.6903 14.2937 12.2126 13.1659 13.3046C13.1656 13.3049 13.1653 13.305 13.1649 13.305ZM11.25 6.75C11.25 7.992 10.242 9 9 9C7.758 9 6.75 7.992 6.75 6.75C6.75 5.508 7.758 4.5 9 4.5C10.242 4.5 11.25 5.508 11.25 6.75ZM27 18C22.0365 18 18 22.0365 18 27C18 31.9635 22.0365 36 27 36C31.9635 36 36 31.9635 36 27C36 22.0365 31.9635 18 27 18ZM31.1649 31.305C31.1644 31.305 31.1639 31.3047 31.1636 31.3041C30.4959 29.6621 28.8927 28.5 27.012 28.5H26.988C26.8152 28.5 26.6447 28.5098 26.477 28.5288C24.195 28.7881 21.0015 29.2967 21.0015 27C21.0015 23.691 23.6925 21 27.0015 21C30.3105 21 33.0015 23.691 33.0015 27C33.0015 28.6903 32.2937 30.2126 31.1659 31.3046C31.1656 31.3049 31.1653 31.305 31.1649 31.305ZM29.25 24.75C29.25 25.992 28.242 27 27 27C25.758 27 24.75 25.992 24.75 24.75C24.75 23.508 25.758 22.5 27 22.5C28.242 22.5 29.25 23.508 29.25 24.75ZM21 6C21 5.172 21.6705 4.5 22.5 4.5H25.5C28.809 4.5 31.5 7.191 31.5 10.5V13.5C31.5 14.328 30.8295 15 30 15C29.1705 15 28.5 14.328 28.5 13.5V10.5C28.5 8.8455 27.1545 7.5 25.5 7.5H22.5C21.6705 7.5 21 6.828 21 6ZM15 30C15 30.828 14.3295 31.5 13.5 31.5H10.5C7.191 31.5 4.5 28.809 4.5 25.5V22.5C4.5 21.672 5.1705 21 6 21C6.8295 21 7.5 21.672 7.5 22.5V25.5C7.5 27.1545 8.8455 28.5 10.5 28.5H13.5C14.3295 28.5 15 29.172 15 30Z" fill="url(#paint0_linear_1203_988)"/>
        <defs>
        <linearGradient id="paint0_linear_1203_988" x1="36" y1="36" x2="-3.8965" y2="30.0542" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FCD535"/>
        <stop offset="1" stopColor="#F49097"/>
        </linearGradient>
        </defs>
        </svg>
        ),
      title: 'Access to a global community of AI/ML experts.'
    },
    {
      icon: (<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 30C26.271 30 33 23.271 33 15C33 6.729 26.271 0 18 0C9.729 0 3 6.729 3 15C3 23.271 9.729 30 18 30ZM18 3C24.6165 3 30 8.3835 30 15C30 21.6165 24.6165 27 18 27C11.3835 27 6 21.6165 6 15C6 8.3835 11.3835 3 18 3ZM36 30.75C36 33.645 33.645 36 30.75 36H5.25C2.355 36 0 33.645 0 30.75C0 29.109 0.783 27.5415 2.094 26.5545C2.757 26.0565 3.6975 26.1915 4.194 26.85C4.692 27.5115 4.56 28.452 3.8985 28.95C3.327 29.379 3 30.036 3 30.7485C3 31.989 4.0095 32.9985 5.25 32.9985H30.75C31.9905 32.9985 33 31.989 33 30.7485C33 30.0345 32.6715 29.379 32.1 28.9485C31.4385 28.449 31.3065 27.5085 31.806 26.847C32.3025 26.1885 33.2445 26.0535 33.906 26.553C35.2365 27.558 36 29.0865 36 30.75ZM21 18C21 17.4315 20.5935 16.953 20.034 16.8585L15.4725 16.0995C13.4595 15.7635 12 14.0385 12 12C12 10.0345 13.2672 8.35892 15.0274 7.74751C15.8099 7.47568 16.5 6.82843 16.5 6C16.5 5.1705 17.172 4.5 18 4.5C18.828 4.5 19.5 5.1705 19.5 6V7.098C19.5 7.32002 19.68 7.5 19.902 7.5C21.5025 7.5 22.9965 8.361 23.799 9.7485C24.213 10.467 23.9685 11.3835 23.2515 11.7975C22.536 12.2145 21.618 11.967 21.2025 11.2515C20.934 10.7865 20.436 10.5 19.902 10.5H16.5C15.6735 10.5 15 11.172 15 12C15 12.5685 15.4065 13.047 15.966 13.1415L20.5275 13.9005C22.5405 14.2365 24 15.9615 24 18C24 19.9655 22.7328 21.6411 20.9726 22.2525C20.1901 22.5243 19.5 23.1716 19.5 24C19.5 24.8295 18.828 25.5 18 25.5C17.172 25.5 16.5 24.8295 16.5 24V22.902C16.5 22.68 16.32 22.5 16.098 22.5C14.4975 22.5 13.0035 21.639 12.201 20.2515C11.787 19.533 12.0315 18.6165 12.7485 18.2025C13.4625 17.7855 14.382 18.033 14.7975 18.7485C15.066 19.2135 15.564 19.5 16.098 19.5H19.5C20.3265 19.5 21 18.828 21 18Z" fill="url(#paint0_linear_1203_986)"/>
        <defs>
        <linearGradient id="paint0_linear_1203_986" x1="36" y1="36" x2="-3.8965" y2="30.0542" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FCD535"/>
        <stop offset="1" stopColor="#F49097"/>
        </linearGradient>
        </defs>
        </svg>
        ),
      title: 'Tools to crowdfund prize pools and resources.'
    },
    {
      icon: (<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 0C8.0745 0 0 8.0745 0 18C0 27.9255 8.0745 36 18 36C27.9255 36 36 27.9255 36 18C36 8.0745 27.9255 0 18 0ZM18 33C9.729 33 3 26.271 3 18C3 17.0297 3.0928 16.0808 3.26987 15.1614C3.59884 13.4533 5.67998 13.0858 6.879 14.346C7.2765 14.763 7.827 15 8.403 15H11.3265C11.7585 15 12.1725 15.171 12.4785 15.477L13.038 16.0365C13.335 16.3335 13.5015 16.7355 13.5015 17.154V18.5985C13.5015 19.176 13.731 19.728 14.139 20.136L15.924 21.921C16.2945 22.2915 16.503 22.794 16.503 23.3175V26.865C16.503 27.768 17.235 28.5 18.138 28.5H18.4575C19.095 28.5 19.674 28.1295 19.941 27.5505L23.3025 20.2665C23.703 19.3995 23.3955 18.372 22.587 17.865L18.744 15.4635C18.2595 15.1605 17.7 15 17.1285 15H14.982C14.5155 15 14.067 14.814 13.737 14.484L12.849 13.596C12.381 13.128 12.381 12.3705 12.849 11.904L13.6425 11.1105C14.007 10.746 14.5635 10.656 15.024 10.887L16.344 11.547C16.8855 11.8185 17.541 11.712 17.97 11.283L17.9745 11.2785C18.432 10.821 18.519 10.1115 18.186 9.558L16.9305 7.464C16.668 7.026 16.674 6.483 16.9515 6.054C18.1659 4.17907 20.3367 3.01464 22.4688 3.68105C24.9662 4.46163 27.1855 5.87867 28.935 7.74173C29.9609 8.8341 29.5401 10.5358 28.242 11.2845C27.507 11.7075 27.1425 12.567 27.3495 13.389L28.29 17.1495C28.425 17.6895 28.7895 18.1425 29.2875 18.39C31.4113 19.4443 32.7095 21.7945 31.763 23.9685C29.4513 29.2782 24.1531 33 18.003 33H18Z" fill="url(#paint0_linear_1203_984)"/>
        <defs>
        <linearGradient id="paint0_linear_1203_984" x1="36" y1="36" x2="-3.8965" y2="30.0542" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FCD535"/>
        <stop offset="1" stopColor="#F49097"/>
        </linearGradient>
        </defs>
        </svg>
        ),
      title: 'Opportunities to co-own and collaborate on solutions.'
    }
  ];

  return (
    <section className={`py-16 ${isDarkMode ? 'bg-[#000000]' : 'bg-white'}`}>
      <div className="max-w-[1300px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <motion.h2 
            className={`text-[32px] sm:text-[36px] font-medium mb-6 ${
              isDarkMode ? 'text-white' : 'text-black'
            } font-lexend`}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            Your Ideas Deserve to Be Built
          </motion.h2>
          <motion.p 
            className={`text-[16px] sm:text-[18px] font-light max-w-[800px] mx-auto ${
              isDarkMode ? 'text-[#fff]' : 'text-[#000]'
            } font-lexend`}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
          >
            LunorQuest empowers individuals to turn their innovative ideas into actionable AI solutions, even if you're just starting with an idea. From collecting data to building models and refining solutions, our platform supports every step of the AI journey
          </motion.p>
        </div>

        <motion.h3 
          className={`text-[24px] font-medium text-center mb-10 ${
            isDarkMode ? 'text-white' : 'text-black'
          } font-lexend`}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
        >
          Key benefits
        </motion.h3>

        <motion.div 
          className="grid grid-cols-1 sm:grid-cols-3 gap-8 sm:gap-0 relative"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.3 }}
        >
          <div className="hidden sm:block absolute left-1/3 top-0 bottom-0 w-[1px] bg-gradient-to-b from-transparent via-[#FCD535] to-transparent" />
          <div className="hidden sm:block absolute left-2/3 top-0 bottom-0 w-[1px] bg-gradient-to-b from-transparent via-[#FCD535] to-transparent" />

          {benefits.map((benefit, index) => (
            <motion.div
              key={index}
              className="px-4"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.4 + index * 0.1 }}
            >
              <BenefitCard {...benefit} />
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default KeyBenefitsSection; 